module.exports = ".error-msg{\r\n    margin-top:-4px;\r\n}\r\n\r\n.input-group label{\r\n    width:100%;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/roles/roles-form/roles-form.component.css
// module id = ./src/app/ultilities/roles/roles-form/roles-form.component.css
// module chunks = main